'use client';

import { __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import { ELanguage } from '../Utils/constants.js';
import { uploadFile, validateFile } from '../services/resumes/index.js';
import { DEFAULT_ALLOW_EXT, DEFAULT_ALLOW_FILES_EXT, DEFAULT_LIMIT_FILE_SIZE } from '../services/resumes/const.js';
import UploadIcon from '../Images/UploadIcon/index.js';
import LoadingIcon from '../Images/LoadingIcon/index.js';
import { NewUIContainer, IconWrapper, InfoMessage, ResponseMsg, Placeholder, Container, Link, ReplaceButton } from './styles.css.js';
import '../Contexts/translator/index.js';
import translations from './translations.js';
import { colors } from '../Colors/index.js';
import { EBoxType } from './type.js';
import { DEFAULT_SECONDARY_DRAG_DROP_FILE_STYLE, DEFAULT_DRAG_DROP_FILE_STYLE } from './constants.js';
import Typography from '../Typography/index.js';
import Button from '../Button/index.js';
import SuccessIcon from '../Images/SuccessIcon/index.js';
import DocumentsIcon from '../Images/DocumentsIcon/index.js';
import { Span } from '../Typography/components/Variant.js';
import { updateSummaryProfileSetting } from '../UploadResumeModal/apiServices.js';
import { randomId, downloadAttachFile } from '../Utils/helpers.js';
import '../Cascader/constants.js';
import ModelError from '../services/model/index.js';
import AddFilledIcon from '../Images/AddFilledIcon/index.js';
import Documentv2Icon from '../Images/Documentv2Icon/index.js';
import { translator } from '../Contexts/translator/helper.js';

var DragDropResumeUpload = function (_a, ref) {
    var _b;
    var accessToken = _a.accessToken, _c = _a.lang, lang = _c === void 0 ? ELanguage.VI : _c, baseUrl = _a.baseUrl, userId = _a.userId, jobId = _a.jobId, contentOptions = _a.contentOptions, onUpload = _a.onUpload, onUploadDone = _a.onUploadDone, onUploadError = _a.onUploadError, isUploadResume = _a.isUploadResume, dragDropStyle = _a.dragDropStyle, _d = _a.boxType, boxType = _d === void 0 ? EBoxType.primary : _d, // read docs stories book for more information,
    style = _a.style, fileInfo = _a.fileInfo, _e = _a.apiUploadVersion, apiUploadVersion = _e === void 0 ? 'v2.0' : _e, _f = _a.isCheckSpam, isCheckSpam = _f === void 0 ? true : _f, _g = _a.isLoading, isLoading = _g === void 0 ? false : _g, _h = _a.isNewUploadUI, isNewUploadUI = _h === void 0 ? false : _h;
    var _j = useState(false), isDrag = _j[0], setIsDrag = _j[1];
    var _k = useState(false), isError = _k[0], setIsError = _k[1];
    var _l = useState((_b = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _b !== void 0 ? _b : null), message = _l[0], setMessage = _l[1];
    var _m = useState(!(fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.name) ? 'none' : 'success'), uploadStatus = _m[0], setUploadStatus = _m[1];
    var _o = useState(fileInfo), file = _o[0], setFile = _o[1];
    var inputRef = useRef(null);
    var unitId = randomId();
    var mergedDragDropStyles = __assign(__assign({}, (boxType === EBoxType.secondary ? DEFAULT_SECONDARY_DRAG_DROP_FILE_STYLE : DEFAULT_DRAG_DROP_FILE_STYLE)), dragDropStyle);
    var t = function (txt) {
        var text = translator(txt, translations, lang !== null && lang !== void 0 ? lang : ELanguage.VI);
        return text;
    };
    var validateResume = function (uploadFileInfo) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, validateFile({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            file: uploadFileInfo,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            userId: userId !== null && userId !== void 0 ? userId : 0,
                            jobId: jobId !== null && jobId !== void 0 ? jobId : 0
                        })];
                case 1:
                    response = _j.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.attributes) && !((_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.spam)) {
                        !isUploadResume &&
                            setMessage(((_d = response.meta) === null || _d === void 0 ? void 0 : _d.statusCode) === 200
                                ? t('Your upload was successful')
                                : (_f = (_e = response === null || response === void 0 ? void 0 : response.meta) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : '');
                        !isUploadResume && setUploadStatus('success');
                        setIsError(false);
                        !isUploadResume && onUpload ? onUpload(uploadFileInfo) : null;
                        return [2 /*return*/, true];
                    }
                    setMessage((_h = (_g = response === null || response === void 0 ? void 0 : response.meta) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : '');
                    setUploadStatus('none');
                    setIsError(true);
                    return [2 /*return*/, false];
                case 2:
                    error_1 = _j.sent();
                    setUploadStatus('none');
                    console.error(error_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var reset = function () {
        var _a;
        if (inputRef.current) {
            setMessage((_a = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _a !== void 0 ? _a : '');
            inputRef.current.value = '';
            if (!/safari/i.test(navigator.userAgent)) {
                inputRef.current.type = '';
                inputRef.current.type = 'file';
            }
        }
    };
    var doUploadFile = function (file, resumeId, customResponseMessage, action) {
        if (resumeId === void 0) { resumeId = -1; }
        if (customResponseMessage === void 0) { customResponseMessage = ''; }
        if (action === void 0) { action = -1; }
        return __awaiter(void 0, void 0, void 0, function () {
            var requestParams, response, responseMessage, jobAlertData, error_2;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (!file)
                            return [2 /*return*/, null];
                        _l.label = 1;
                    case 1:
                        _l.trys.push([1, 7, , 8]);
                        if (isLoading)
                            setUploadStatus('processing');
                        requestParams = {
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            file: file,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            resumeId: resumeId,
                            apiUploadVersion: apiUploadVersion
                        };
                        if (action !== -1) {
                            requestParams.action = action;
                        }
                        return [4 /*yield*/, uploadFile(requestParams)];
                    case 2:
                        response = _l.sent();
                        if (response instanceof ModelError) {
                            setIsError(true);
                            setUploadStatus('none');
                            setMessage((_b = (_a = response === null || response === void 0 ? void 0 : response.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : '');
                            onUploadError && onUploadError(response);
                            return [2 /*return*/, null];
                        }
                        if (!(response && response.data)) return [3 /*break*/, 5];
                        onUploadDone && onUploadDone(response);
                        responseMessage = customResponseMessage !== '' ? customResponseMessage : (_c = response === null || response === void 0 ? void 0 : response.message) !== null && _c !== void 0 ? _c : '';
                        setMessage(response.status === 200 ? t('Your upload was successful') : responseMessage);
                        setFile({
                            name: (_e = (_d = response.data) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : ' ',
                            link: (_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.link) !== null && _g !== void 0 ? _g : '',
                            id: (_j = (_h = response.data) === null || _h === void 0 ? void 0 : _h.id) !== null && _j !== void 0 ? _j : 0
                        });
                        jobAlertData = response.data.job_alert_data;
                        if (!((jobAlertData === null || jobAlertData === void 0 ? void 0 : jobAlertData.summary) && jobAlertData.summary !== '')) return [3 /*break*/, 4];
                        return [4 /*yield*/, updateSummaryProfileSetting({
                                url: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                                summary: (_k = jobAlertData.summary) !== null && _k !== void 0 ? _k : '',
                                accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : ''
                            })];
                    case 3:
                        _l.sent();
                        _l.label = 4;
                    case 4:
                        setUploadStatus('success');
                        setIsError(false);
                        return [2 /*return*/, response.data];
                    case 5:
                        onUploadError && onUploadError(response);
                        _l.label = 6;
                    case 6: return [2 /*return*/, null];
                    case 7:
                        error_2 = _l.sent();
                        setUploadStatus('none');
                        console.error(error_2);
                        return [2 /*return*/, null];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    useImperativeHandle(ref, function () {
        return {
            reset: reset,
            doUploadFile: function (file, resumeId, customResponseMessage, action) {
                if (customResponseMessage === void 0) { customResponseMessage = ''; }
                if (action === void 0) { action = -1; }
                return doUploadFile(file, resumeId, customResponseMessage, action);
            }
        };
    }, [accessToken]);
    var checkUploadFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var uploadFileInfo, isValid, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setUploadStatus('processing');
                    uploadFileInfo = file;
                    // check file extensions
                    if (!DEFAULT_ALLOW_FILES_EXT.includes(uploadFileInfo.type)) {
                        // show error file type doesn't support
                        setMessage(t('.doc, .docx and .pdf files that are less than 5120KB in size'));
                        setIsError(true);
                        setUploadStatus('none');
                        return [2 /*return*/];
                    }
                    // check file size
                    if (uploadFileInfo.size > DEFAULT_LIMIT_FILE_SIZE) {
                        // File is over 5MB
                        setMessage(t('.doc, .docx and .pdf files that are less than 5120KB in size'));
                        setIsError(true);
                        setUploadStatus('none');
                        return [2 /*return*/];
                    }
                    // validate spam cv
                    setMessage((_b = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.msg) !== null && _b !== void 0 ? _b : '');
                    if (!isCheckSpam) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateResume(file)];
                case 1:
                    _a = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = true;
                    _c.label = 3;
                case 3:
                    isValid = _a;
                    // do upload file
                    if (isUploadResume && isValid) {
                        doUploadFile(uploadFileInfo);
                    }
                    if (!isCheckSpam && !isUploadResume) {
                        setIsError(false);
                        setUploadStatus('success');
                        onUpload && onUpload(file);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnFileChange = function (e) {
        if (e.target.files !== null && e.target.files.length > 0) {
            checkUploadFile(e.target.files[0]);
        }
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setIsDrag(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setIsDrag(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setIsDrag(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            checkUploadFile(e.dataTransfer.files[0]);
        }
    };
    var renderIcon = function () {
        switch (uploadStatus) {
            case 'none':
                // Removed settingIcon
                return React__default.createElement(AddFilledIcon, null);
            case 'processing':
                return React__default.createElement(LoadingIcon, null);
            case 'success':
                return boxType === EBoxType.primary ? React__default.createElement(UploadIcon, null) : React__default.createElement(SuccessIcon, { width: 24, height: 24 });
            default:
                return null;
        }
    };
    var renderLabel = function () {
        if (boxType === EBoxType.primary) {
            return t('Upload file from your device');
        }
        switch (uploadStatus) {
            case 'success':
                return t('Upload success');
            default:
                return t('Drag your file here');
        }
    };
    var renderResponseMsgColor = function () {
        switch (boxType) {
            case EBoxType.primary:
                return isError ? colors.error[40] : colors.grey[60];
            case EBoxType.secondary:
                if (uploadStatus === 'success') {
                    return colors.grey[20];
                }
                return isError ? colors.error[40] : colors.grey[60];
            default:
                return isError ? colors.error[40] : colors.grey[60];
        }
    };
    useEffect(function () {
        var _a;
        setIsError(!!(contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg));
        setMessage((_a = contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg) !== null && _a !== void 0 ? _a : t('.doc, .docx and .pdf files that are less than 5120KB in size'));
    }, [contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.errMsg]);
    if (isNewUploadUI) {
        return (React__default.createElement(NewUIContainer, { style: style, className: 'body__uploadCV', htmlFor: "upload_cv_".concat(unitId), onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDrop: handleOnDrop, active: isDrag, disable: false, boxType: boxType, dragDropStyles: mergedDragDropStyles },
            React__default.createElement(IconWrapper, null,
                React__default.createElement(Documentv2Icon, null)),
            React__default.createElement("input", { id: "upload_cv_".concat(unitId), type: 'file', ref: inputRef, accept: DEFAULT_ALLOW_EXT, onChange: handleOnFileChange }),
            React__default.createElement(InfoMessage, null, t('Drag & drop your CV here to quickly create your profile with AI')),
            React__default.createElement(ResponseMsg, { variant: 'p', name: 'body', size: boxType === EBoxType.primary ? 'small' : 'medium', isPlaceholder: !isError, color: renderResponseMsgColor() }, message || t('.doc, .docx and .pdf files that are less than 5120KB in size')),
            React__default.createElement(Placeholder, { boxType: boxType },
                React__default.createElement(Button, { isRounded: true, type: 'highlight', outline: 'outline', size: 'sm', onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.placeholder) || renderLabel()))));
    }
    return (React__default.createElement(Container, { style: style, className: 'body__uploadCV', htmlFor: "upload_cv_".concat(unitId), onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDrop: handleOnDrop, active: isDrag, disable: false, boxType: boxType, dragDropStyles: mergedDragDropStyles },
        React__default.createElement("input", { id: "upload_cv_".concat(unitId), type: 'file', ref: inputRef, accept: DEFAULT_ALLOW_EXT, onChange: handleOnFileChange }),
        React__default.createElement(Placeholder, { boxType: boxType },
            React__default.createElement(Button, { iconPosition: 'left', iconComponent: renderIcon(), isRounded: true, type: 'highlight', onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.placeholder) || renderLabel()),
            boxType === EBoxType.secondary && (React__default.createElement(React__default.Fragment, null, !(file === null || file === void 0 ? void 0 : file.name) ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Typography, { variant: 'p', name: 'body', size: 'medium', color: colors.grey[20] }, t('or')),
                React__default.createElement(Button, { onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, type: 'primary' }, t('Choose file to upload')))) : (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Link, { name: 'body', size: 'medium', color: colors.primary[40], href: '#', onClick: function (e) {
                        var _a;
                        e.preventDefault();
                        if (!(file === null || file === void 0 ? void 0 : file.id)) {
                            return;
                        }
                        downloadAttachFile({
                            resumeId: file === null || file === void 0 ? void 0 : file.id,
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            msBaseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            fileName: (_a = file === null || file === void 0 ? void 0 : file.name) !== null && _a !== void 0 ? _a : ''
                        });
                    }, target: '_blank', isDragging: isDrag },
                    React__default.createElement(Span, { name: 'body', size: 'medium', color: colors.primary[40], style: { width: '100%', marginLeft: 4, textAlign: 'unset' } },
                        React__default.createElement(DocumentsIcon, { style: { marginBottom: -1 } }),
                        " ",
                        React__default.createElement("span", null, file.name)))))))),
        React__default.createElement(ResponseMsg, { variant: 'p', name: 'body', size: boxType === EBoxType.primary ? 'small' : 'medium', isPlaceholder: !isError, color: renderResponseMsgColor() },
            (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.customMsg) ? (React__default.createElement(React__default.Fragment, null, contentOptions === null || contentOptions === void 0 ? void 0 :
                contentOptions.customMsg,
                React__default.createElement("br", null))) : (''),
            message || t('.doc, .docx and .pdf files that are less than 5120KB in size')),
        boxType === EBoxType.secondary && (file === null || file === void 0 ? void 0 : file.name) ? (React__default.createElement(ReplaceButton, { outline: 'outline', size: 'md', type: 'default' }, t('Replace file'))) : null));
};
var DragDropResumeUpload$1 = forwardRef(DragDropResumeUpload);

export { DragDropResumeUpload$1 as default };
//# sourceMappingURL=index.js.map
